import { Button, Media, ButtonGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import userPerfilImg from '../../../images/userperfil.png';

export const customTableColumns = (setShowEmployeeHalfDaysModal) => [
  {
    Header: 'Empleado',
    Filter: '',
    Cell: (props) => {
      return (
        <Media>
          <img 
            className="user-pic" 
            src={props.row?.original?.foto ? `${process.env.REACT_APP_URL}${props.row.original.foto}` : userPerfilImg}
            alt="Foto de empleado" /> 
          <Media.Body>
            <h6 className="m-0 font-weight-bold">{props.row && props.row.original && props.row.original.nombre}</h6>
            <p className="m-0">{props.row && props.row.original && props.row.original.puesto}</p>
          </Media.Body>
        </Media>
      )
    }
  },
  {
    Header: "Saldo de vacaciones",
    Filter: '',
    Cell: (props) => props.row.original.indicadores && props.row.original.indicadores.Disponibles ? props.row.original.indicadores.Disponibles : 0
  },
  {
    Header: "Saldo Total",
    Filter: '',
    Cell: (props) => props.row.original.indicadores && props.row.original.indicadores.Total ? props.row.original.indicadores.Total : 0
  },
  {
    Header: "Saldo programado",
    Filter: '',
    Cell: (props) => props.row.original.indicadores && props.row.original.indicadores.Programados ? props.row.original.indicadores.Programados : 0
  },
  {
    Header: "Saldo restante",
    Filter: '',
    Cell: (props) => props.row.original.indicadores && props.row.original.indicadores.Pendientes ? props.row.original.indicadores.Pendientes : 0
  },
  {
    Header: "Porcentaje de cumplimiento",
    Filter: '',
    Cell: (props) => props.row.original.indicadores && props.row.original.indicadores.Cumplimiento ? props.row.original.indicadores.Cumplimiento : 0
  },
  {
    Header: "Tiempo compensatorio disponible",
    Filter: '',
    Cell: (props) => props.row.original.indicadores_tiempos_compensatorios && props.row.original.indicadores_tiempos_compensatorios.tiempo_compensatorio_disponible ? props.row.original.indicadores_tiempos_compensatorios.tiempo_compensatorio_disponible : 0
  },
  {
    Header: "Tiempo compensatorio programado",
    Filter: '',
    Cell: (props) => props.row.original.indicadores_tiempos_compensatorios && props.row.original.indicadores_tiempos_compensatorios.tiempo_compensatorio_programados ? props.row.original.indicadores_tiempos_compensatorios.tiempo_compensatorio_programados : 0
  },
  {
    Header: "Tiempo compensatorio pendiente",
    Filter: '',
    Cell: (props) => props.row.original.indicadores_tiempos_compensatorios && props.row.original.indicadores_tiempos_compensatorios.tiempo_compensatorio_restante ? props.row.original.indicadores_tiempos_compensatorios.tiempo_compensatorio_restante : 0
  },
 {
    Header: "Cumplimiento de tiempo compensatorio",
    Filter: '',
    Cell: (props) => props.row.original.indicadores_tiempos_compensatorios && props.row.original.indicadores_tiempos_compensatorios.tiempo_compensatorio_cumplimiento ? props.row.original.indicadores_tiempos_compensatorios.tiempo_compensatorio_cumplimiento : 0
  },
  {
    id: "customButtons",
    Filter: "",
    Cell: (value) => (
     <ButtonGroup>
       <Link
          size="sm"
          variant="link"
          type="button"
          to={`/planificador-vacaciones/${value.row.original.codigo_empleado}`}
          //onClick={() => onEdit(value.row.original, value.row.index)}
        >
          <i className="material-icons">date_range</i>
        </Link>
        <Button
          className="m-0 p-0"
          size="sm"
          variant="link"
          type="button"
          onClick={() => setShowEmployeeHalfDaysModal(true, value.row.original)} >
          <i className="material-icons">perm_contact_calendar</i>
        </Button>
     </ButtonGroup>
    ),
  }
];

